<template>
  <v-container fluid>
    <section class="content-header">
      <v-toolbar dense color="#96298A" dark>
      <v-toolbar-title>Rastrear</v-toolbar-title>
      <v-divider class="mx-4" vertical></v-divider>
      <v-text-field
          v-model="guia_interna"
          :readonly="readOnlyGuiaInterna"
          label="Guía a Rastrear"
          append-icon="mdi-earth"
          full-width
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn @click="rastrear" color="primary"
            >Rastrear <v-icon dark right>mdi-earth</v-icon></v-btn
          ><v-divider class="mx-4" vertical></v-divider>
          <v-btn @click="resetRastreo" dark color="grey darken-1"
            >Resetear <v-icon dark right>mdi-eraser</v-icon></v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card v-if="encontrado && !multiGuias" rounded>
          <v-card-text>
            <v-row>
              <div class="text text-lg-h6">Waybill : {{ guia_interna }}</div>
            </v-row>
            <v-row>
              <div class="text text-lg-h6 red">
                Signed for by : {{ signedForByName }}
              </div>
            </v-row>
            <v-row>
              <div class="text text-xl-h4">Result Sumary :</div>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th v-for="(hs,index) in headersSumary" :key="index">
                          {{ hs }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(ds,index) in datosSumary" :key="index">
                        <td>{{ ds.Reference }}</td>
                        <td>{{ ds.Date }}</td>
                        <td>{{ ds.OriginSA }}</td>
                        <td>{{ ds.DestinationSA }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row>
              <div class="text text-xl-h4">Tracking :</div>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th v-for="(ht,index) in headersTracking" :key="index">
                          {{ ht }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dt,index) in datosTracking" :key="index">
                        <td>{{ dt.Date }}</td>
                        <td>{{ dt.Time }}</td>
                        <td>{{ dt.ActivityLocation.Address.City }}</td>
                        <td>{{ dt.Status.StatusType.Description }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card v-if="encontrado && multiGuias" rounded>
          <v-card-text>
            <v-tabs dark background-color="light-blue darken-2" show-arrows v-model="tab" icons-and-text>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="(pkg,i) in track.package" :key="i" :href="'#tab-' + i">
              Paquete - {{ i + 1 }} <v-icon>mdi-package-variant-closed</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(pkg,i) in track.package" :key="i" :value="'tab-' + i">
              <v-card>
                <v-card-text>
                  <v-row>
                    <div class="text text-lg-h6">Waybill : {{ guia_interna }}</div>
                  </v-row>
                  <v-row>
                    <div class="text text-lg-h6 red">
                      Signed for by : {{ signedForByName }}
                    </div>
                  </v-row>
                  <v-row>
                    <div class="text text-xl-h4">Result Sumary :</div>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th v-for="hs in headersSumary" :key="hs">
                                {{ hs }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ pkg.trackingNumber }}</td>
                              <td>{{  }}</td>
                              <td>{{ pkg.packageAddress[0].address.city }}</td>
                              <td>{{ pkg.packageAddress[1].address.city }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <div class="text text-xl-h4">Tracking :</div>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th v-for="ht in headersTracking" :key="ht">
                                {{ ht }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="dt in pkg.activity" :key="dt.date + dt.time">
                              <td>{{ dt.date }}</td>
                              <td>{{ dt.time }}</td>
                              <td>{{ dt.location.address.city }}</td>
                              <td>{{ dt.status.description }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import apicon from '../plugins/apicon';
import $ from 'jquery';
export default {
  created: function () {},
  data() {
    return {
      encontrado: false,
      multiGuias: false,
      tab: null,
      track: [],
      readOnlyGuiaInterna: false,
      guia_interna: null,
      signedForByName: null,
      headersSumary: [
        "Reference",
        "Date",
        "Origin Service Area",
        "Destination Service Area",
      ],
      datosSumary: [],
      headersTracking: [
        "Date",
        "Time",
        "Location Service Area",
        "Checkpoint Details",
      ],
      datosTracking: [],
    };
  },
  methods: {
    resetRastreo: function () {
      this.datosTracking = [];
      this.datosSumary = [];
      this.guia_interna = null;
      this.encontrado = false;
      this.signedForByName = null;
      this.readOnlyGuiaInterna = false;
    },
    rastrear: async function () {
      var url = "rastrearguia/" + this.guia_interna;
      await apicon.getDataApi(apicon.getApiBaseUrl() + url).then((result) => {
        this.encontrado = true;
        this.setupData(result);
      });
    },
    setupData: function (result) {
      //verificar el proveedor
      if (result.proveedor == "UPS") {
        //Indeitificar si son multi guias
        result.datos = result.datos[0];
        if (result.datos.package.trackingNumber === undefined) {
          this.multiGuias = true;
          this.track = result.datos;
        } else {
          var datosT = [];
          this.multiGuias = false;
          var totlarg = result.datos.package.activity.length;
          var firma = "...";

          this.datosSumary = [
              {
                Reference: result.datos.ShipmentIdentificationNumber,
                Date: result.datos.PickupDate,
                OriginSA: result.datos.Shipper.Address["City"],
                DestinationSA: result.datos.ShipTo.Address["City"],
              },
            ];

          if (totlarg > 1) {
            //Datos del Tracking
            datosT = result.datos.Package.Activity;
            //verificar si tiene firma
            $.each(datosT, function (i, item) {
              if (item.Status.StatusType.Code == "D") {
                firma =
                  item.ActivityLocation.SignedForByName +
                  " (" +
                  item.Date +
                  " / " +
                  item.Time +
                  ")";
              }
            });
            //verificar si tiene firma END
            this.readOnlyGuiaInterna = true;
            this.signedForByName = firma;
            this.datosTracking = datosT;
          }
          //verificar si es import
          if(result.guia.tipoguia == 'importacion'){
              this.signedForByName = result.guia.podnombre + '(' + result.guia.podfecha + '-' + result.guia.podhora + ')';
              var evtsStatus = result.estatus;
              $.each(evtsStatus, function (i, item) {
                datosT.push({
                  Date: item.fecha,
                  Time: item.hora,
                  ActivityLocation: {
                    Address: {
                      City: item.comentarios,
                    },
                  },
                  Status: {
                    StatusType: {
                      Description: item.estatus != null ? item.estatus.descripcion : null,
                    },
                  },
                });
              });
              //Sortear
              this.datosTracking = datosT.sort((a,b) => {return (new Date(a.Date) < new Date(b.Date)) ? 1: -1});
            }
        }
      } else if (result.proveedor == "DHL") {
        this.multiGuias = false;
        let datosT = [];
        let shipment = result.datos.shipments[0];
        let evts = shipment.events;
        // Sort events from newest to oldest
        evts.sort((a, b) => {
          // Compare dates first
          const dateA = new Date(`${a.date} ${a.time}`);
          const dateB = new Date(`${b.date} ${b.time}`);
          return dateB - dateA; // Descending order (newest first)
        });
        let totlarg = evts.length;

        if (totlarg > 1) {
         //Datos del Tracking
          $.each(evts, function (i, item) {
            datosT.push({
              Date: item.date,
              Time: item.time,
              ActivityLocation: {
                Address: {
                  City: item.serviceArea[0].description,
                },
              },
              Status: {
                StatusType: {
                  Description: item.description,
                },
              },
            });
          });
          this.signedForByName = result.guia.podnombre + " (" + result.guia.podfecha + " / " + result.guia.podhora + ")";
          this.datosTracking = datosT;
          //verificar si es import
          if(result.guia.tipoguia == 'importacion'){
            this.signedForByName = result.guia.podnombre + '(' + result.guia.podfecha + '-' + result.guia.podhora + ')';
            var evtsStatus = result.estatus;
            $.each(evtsStatus, function (i, item) {
              datosT.push({
                Date: item.fecha,
                Time: item.hora,
                ActivityLocation: {
                  Address: {
                    City: item.comentarios,
                  },
                },
                Status: {
                  StatusType: {
                    Description: item.estatus != null ? item.estatus.descripcion : null,
                  },
                },
              });
            });
            //Sortear
            this.datosTracking = datosT.sort((a,b) => {return (new Date(a.Date) < new Date(b.Date)) ? -1: 1});
          }
        }
           //verificar si tiene firma END
        this.datosSumary = [
          {
            Reference: shipment.shipmentTrackingNumber,
            Date: shipment.shipmentTimeStamp,
            OriginSA:
              shipment.shipperDetails.serviceArea[0].description,
            DestinationSA:
              shipment.receiverDetails.serviceArea[0].description,
          },
        ];
        this.readOnlyGuiaInterna = true;
      } else if (result.proveedor == "FedEx"){
        this.multiGuias = false;
        this.datosTracking = result.datos.eventData.map((item) => ({
          Date: item.date,
          Time: item.time,
          ActivityLocation: {
            Address: {
              City: item.location,
            },
          },
          Status: {
            StatusType: {
              Description: item.status,
            },
          },
        }));
        this.datosSumary = [
          {
            Reference: result.datos.summary.reference,
            Date: result.datos.summary.date,
            OriginSA: result.datos.summary.origin,
            DestinationSA: result.datos.summary.destination,
          },
        ];
        this.signedForByName = result.data.firma;
      }else if (result.proveedor == "Otros") {
        var datosT = [];
        var evts = result.datos;
        var firma = result.guia.podnombre + '(' + result.guia.podfecha + '-' + result.guia.podhora + ')';
        //Datos del Tracking
        $.each(evts, function (i, item) {
          datosT.push({
            Date: item.fecha,
            Time: item.hora,
            ActivityLocation: {
              Address: {
                City: item.comentarios,
              },
            },
            Status: {
              StatusType: {
                Description: item.estatus.descripcion,
              },
            },
          });
        });
        this.signedForByName = firma;
        this.datosTracking = datosT;
        //verificar si tiene firma END
        this.datosSumary = [
          {
            Reference: result.guia.guia_proveedor,
            Date: result.guia.created_at,
            OriginSA: result.guia.pais_e,
            DestinationSA: result.guia.pais_c,
          },
        ];
        this.readOnlyGuiaInterna = true;
      } else if (result.proveedor == "CL"){
        var datosT = [];
        var evts = result.datos;
        var firma = result.guia.pod_nombre + '(' + result.guia.pod_fecha + '-' + result.guia.pod_hora + ')';
        //Datos del Tracking
        $.each(evts, function (i, item) {
          datosT.push({
            Date: item.fecha,
            Time: item.hora,
            ActivityLocation: {
              Address: {
                City: item.comentarios,
              },
            },
            Status: {
              StatusType: {
                Description: item.estatus.descripcion,
              },
            },
          });
        });
        this.signedForByName = firma;
        this.datosTracking = datosT;
        //verificar si tiene firma END
        this.datosSumary = [
          {
            Reference: result.guia.guia_agente,
            Date: result.guia.created_at,
            OriginSA: result.guia.pais_origen,
            DestinationSA: result.guia.ciudad,
          },
        ];
        this.readOnlyGuiaInterna = true;
      }
    },
    getEstatusTrackingData: function(datos){

    }
  },
  mounted() {
    apicon.setAuthHeaders();
  },
};
</script>
